import helper from './helper'

export default {
  login (data) {
    console.log('parameter', data)
    return axios.post(`auth/login`, helper.formData(data))
      .then(response => response.data)
  },

  logout () {
    return axios.post(`auth/logout`)
      .then(response => response.data)
  },

  check () {
    return axios.post(`auth/check`, helper.formData({role: 3}))
      .then(response => response.data)
  },

  getUsers (data) {
    console.log('parameter', data)
    return axios.post(`users`, helper.formData(data))
      .then(response => response.data)
  },

  resetPassword (data) {
    console.log('parameter', data)
    return axios.post(`auth/password/set`, helper.formData(data))
      .then(response => response.data)
  },

  getUser (data) {
    console.log('parameter', data)
    return axios.post(`user`, helper.formData(data))
      .then(response => response.data)
  },

  deleteUser (data) {
    return axios.post(`user/delete`, helper.formData(data))
      .then(response => response.data)
  },

  updateUser (data) {
    return axios.post(`user/update`, helper.formData(data))
      .then(response => response.data)
  },

  createSitter (data) {
    return axios.post(`sitter/create`, helper.formData(data))
      .then(response => response.data)
  },

  getReports(data) {
    return axios.post(`reports`, helper.formData(data))
      .then(response => response.data)
  },

  createNotice(data = {}) {
    return axios.post('notice/create', helper.formData(data))
      .then(response => response.data)
  },

  updateNotice(data = {}) {
    return axios.post('notice/update', helper.formData(data))
      .then(response => response.data)
  },

  deleteNotice(data = {}) {
    return axios.post('notice/delete', helper.formData(data))
      .then(response => response.data)
  },

  getNotice(data = {}) {
    return axios.post(`notice`, helper.formData(data))
      .then(response => response.data)
  },

  getNotices(data = {}) {
    return axios.post(`notices`, helper.formData(data))
      .then(response => response.data)
  },

  sendSitterRequest(data = {}) {
    return axios.post(`sitter/request`, helper.formData(data))
      .then(response => response.data)
  }
}
